export default "__VITE_ASSET__BHu5U0kp__"